import React, { useState } from "react";
import { useToast } from "../hooks/use-toast";
import { createInquiry } from "../lib/firestoreInquiries";

export default function ContactPage() {
  const { toast } = useToast();
  const [form, setForm] = useState({ email: "", whatsapp: "", instagram: "", facebook: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await createInquiry({
        source: "contact",
        ...form,
      });
      toast({ title: "Thanks — we received your details", description: "We'll get back to you shortly." });
      setForm({ email: "", whatsapp: "", instagram: "", facebook: "", message: "" });
    } catch {
      toast({ title: "Unable to submit right now", description: "Please try again in a moment." });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white py-24">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="font-display text-4xl md:text-5xl mb-6">Contact & Socials</h1>
        <p className="text-white/70 mb-8">Share your preferred contact details and social handles. We'll use these to reach out via WhatsApp or email.</p>

        <form onSubmit={handleSubmit} className="space-y-6 bg-white/5 p-6 rounded-md">
          <div>
            <label className="text-sm text-white/70 block mb-2">Email</label>
            <input name="email" value={form.email} onChange={handleChange} type="email" placeholder="you@domain.com" className="w-full p-3 rounded bg-white/5 border border-white/10" />
          </div>

          <div>
            <label className="text-sm text-white/70 block mb-2">WhatsApp number (with country code)</label>
            <input name="whatsapp" value={form.whatsapp} onChange={handleChange} placeholder="919812345678" className="w-full p-3 rounded bg-white/5 border border-white/10" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-sm text-white/70 block mb-2">Instagram handle</label>
              <input name="instagram" value={form.instagram} onChange={handleChange} placeholder="@yourhandle" className="w-full p-3 rounded bg-white/5 border border-white/10" />
            </div>
            <div>
              <label className="text-sm text-white/70 block mb-2">Facebook handle</label>
              <input name="facebook" value={form.facebook} onChange={handleChange} placeholder="facebook.com/yourpage" className="w-full p-3 rounded bg-white/5 border border-white/10" />
            </div>
          </div>

          <div>
            <label className="text-sm text-white/70 block mb-2">Message (optional)</label>
            <textarea name="message" value={form.message} onChange={handleChange} rows={4} className="w-full p-3 rounded bg-white/5 border border-white/10" />
          </div>

          <div className="flex items-center justify-between">
            <button type="submit" disabled={submitting} className="bg-[#C9A961] text-black px-6 py-3 rounded font-semibold disabled:opacity-60">
              {submitting ? "Sending..." : "Send details"}
            </button>
            <div className="text-white/60 text-sm">We'll never share your details publicly.</div>
          </div>
        </form>
      </div>
    </div>
  );
}
